export enum AuthType {
  Reg = 'registration',
  Auth = 'authentication',
  Bind = 'bind',
}
